import {DISCUSSION_API, ADD_DISCUSSION_LIKE_ERROR} from '../../../constants';

export const addDiscussionLike = async ({
    discussionId,
    userId
}) => {
    try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await fetch(`${DISCUSSION_API}/${discussionId}/likes`, {
            method: 'POST',
            headers: new Headers({
                'x-access-token': user.accessToken,
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                userId
            })
        });
        if (!response.ok) throw response;
        const responseJson = await response.json();
        return responseJson;
    } catch (error) {
        throw ADD_DISCUSSION_LIKE_ERROR;
    }
};